import { render } from "./BecomeVendorView.vue?vue&type=template&id=a926adb6"
import script from "./BecomeVendorView.vue?vue&type=script&lang=js"
export * from "./BecomeVendorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__